<div id="domiciliacion-ct">
  <div class="kb-card">
    <div class="kb-card-header">
      <div class="flex items-center justify-between gap-2">
        <div>
          <div class="kb-card-title"><i class="fas fa-university mr-2"></i>Domiciliación con CrediTotal</div>
          <div class="kb-card-desc">Qué clientes reciben la invitación a aceptar los términos nuevos y qué empresa cobra los lotes nuevos de BDV y Mercantil.</div>
        </div>
        <button *ngIf="!sinPermiso" type="button" class="kb-btn kb-btn-outline kb-btn-sm" [disabled]="cargando || verificando || guardando" (click)="cargar()">
          <i class="fas fa-sync-alt" [class.fa-spin]="cargando || verificando"></i> Actualizar
        </button>
      </div>
    </div>

    <div class="kb-card-body">
      <!-- Sin permiso -->
      <div *ngIf="sinPermiso" class="kb-aviso kb-aviso-info" id="dct-sin-permiso">
        <i class="fas fa-lock"></i><div>No tiene permiso para ver esta sección.</div>
      </div>

      <div *ngIf="error" class="kb-aviso kb-aviso-peligro mb-3" id="dct-error"><i class="fas fa-exclamation-triangle"></i><div>{{ error }}</div></div>
      <div *ngIf="cargando && !estado && !sinPermiso" class="kb-hint">Cargando…</div>

      <ng-container *ngIf="estado">
        <!-- 1. Estado -->
        <div class="kb-stat-grid mb-4" id="dct-estado">
          <div class="kb-stat">
            <div class="kb-stat-label">Invitación a los clientes</div>
            <div class="kb-stat-valor"><span class="kb-badge" [ngClass]="claseInvitacion()">{{ textoInvitacion() }}</span></div>
          </div>
          <div class="kb-stat">
            <div class="kb-stat-label">Empresa que cobra los lotes nuevos</div>
            <div class="kb-stat-valor">{{ textoEmpresa() }}</div>
            <div class="kb-stat-pie" *ngIf="estado.fecha_efectiva">Rige desde {{ estado.fecha_efectiva | date:'dd/MM/yyyy HH:mm' }}</div>
            <div class="kb-stat-pie" *ngIf="!estado.fecha_efectiva">Sin fecha de cambio todavía</div>
          </div>
        </div>

        <!-- 2. Aceptaciones y datos de cobro -->
        <div class="grid gap-4 md:grid-cols-2 mb-4">
          <div id="dct-aceptaciones">
            <div class="kb-section-title">Clientes que ya aceptaron</div>
            <div *ngIf="!estado.aceptaciones?.length" class="kb-empty"><div class="kb-empty-texto">Todavía nadie ha aceptado.</div></div>
            <div *ngIf="estado.aceptaciones?.length" class="kb-table-envoltorio">
              <table class="kb-table">
                <thead class="kb-thead"><tr><th class="kb-th">Banco</th><th class="kb-th">Producto</th><th class="kb-th kb-th-num">Aceptaron</th></tr></thead>
                <tbody>
                  <tr class="kb-tr" *ngFor="let a of estado.aceptaciones">
                    <td class="kb-td">{{ a.banco_nombre || a.banco }}</td>
                    <td class="kb-td">{{ a.producto }}</td>
                    <td class="kb-td kb-td-num">{{ a.total }}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
          <div id="dct-cobro">
            <div class="kb-section-title">Datos de cobro de CrediTotal por banco</div>
            <div *ngIf="!estado.ordenante?.length" class="kb-empty"><div class="kb-empty-texto">Sin información de bancos.</div></div>
            <div *ngIf="estado.ordenante?.length" class="kb-table-envoltorio">
              <table class="kb-table">
                <thead class="kb-thead"><tr><th class="kb-th">Banco</th><th class="kb-th">Estado</th></tr></thead>
                <tbody>
                  <tr class="kb-tr" *ngFor="let o of estado.ordenante">
                    <td class="kb-td">{{ o.banco_nombre || o.banco }}</td>
                    <td class="kb-td">
                      <span class="kb-badge" [ngClass]="o.completo ? 'kb-badge-exito' : 'kb-badge-alerta'">{{ textoCobro(o) }}</span>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>

        <!-- 3. Verificación -->
        <div class="mb-4" id="dct-verificacion">
          <div class="flex items-center justify-between gap-2 mb-2">
            <div class="kb-section-title">¿Está todo listo para pasar a CrediTotal?
              <span *ngIf="verificacion" class="kb-badge ml-2" [ngClass]="verificacion.resultado === 'APROBADA' ? 'kb-badge-exito' : 'kb-badge-peligro'">
                {{ verificacion.resultado === 'APROBADA' ? 'Aprobada' : 'Rechazada' }}
              </span>
            </div>
            <button type="button" class="kb-btn kb-btn-outline kb-btn-sm" [disabled]="verificando || guardando" (click)="verificar()">
              <i class="fas fa-check-double"></i> Volver a verificar
            </button>
          </div>
          <div *ngIf="errorVerificacion" class="kb-aviso kb-aviso-alerta mb-2"><i class="fas fa-exclamation-triangle"></i><div>{{ errorVerificacion }}</div></div>
          <div *ngIf="verificacion">
            <div class="dct-revision flex items-start gap-3" *ngFor="let r of verificacion.revisiones">
              <span class="kb-badge" [ngClass]="claseEstadoRevision(r.estado)">{{ textoEstadoRevision(r.estado) }}</span>
              <div>
                <div class="font-medium">{{ r.titulo }}</div>
                <div class="kb-hint">{{ r.detalle }}</div>
              </div>
            </div>
          </div>
        </div>

        <!-- 4. Acciones -->
        <div class="grid gap-4 md:grid-cols-2 mb-4" id="dct-acciones">
          <div class="border rounded-lg p-4">
            <div class="kb-section-title">A quién se invita</div>
            <p class="kb-hint mb-2">La opción «grupo piloto» solo aparece si hay personas en el grupo piloto.</p>
            <div class="flex items-center gap-2">
              <div class="kb-select-envoltorio flex-1">
                <select class="kb-select" [(ngModel)]="modoElegido" [disabled]="guardando" aria-label="A quién se invita">
                  <option *ngFor="let m of modosDisponibles()" [ngValue]="m">{{ textoModo(m) }}</option>
                </select>
              </div>
              <button type="button" class="kb-btn kb-btn-primary" [disabled]="!puedeCambiarInvitacion()" (click)="cambiarInvitacion()">Cambiar invitación</button>
            </div>
          </div>
          <div class="border rounded-lg p-4">
            <div class="kb-section-title">Qué empresa cobra los lotes nuevos</div>
            <p class="kb-hint mb-2">Hoy cobra {{ textoEmpresaCorta(estado.empresa) }}.</p>
            <div class="flex flex-wrap gap-2">
              <button *ngIf="estado.empresa !== 'CT'" type="button" class="kb-btn kb-btn-primary" [disabled]="!puedePasarACt()" (click)="cambiarEmpresa('CT')">
                <i class="fas fa-toggle-on"></i> Pasar a CrediTotal
              </button>
              <button *ngIf="estado.empresa === 'CT'" type="button" class="kb-btn kb-btn-outline" [disabled]="!puedeVolverAMt()" (click)="cambiarEmpresa('MT')">
                <i class="fas fa-undo"></i> Volver a Mundo Total
              </button>
            </div>
            <p class="kb-hint mt-2" *ngIf="estado.empresa !== 'CT' && verificacion && verificacion.resultado !== 'APROBADA'">
              El botón se habilita cuando la verificación esté aprobada.
            </p>
          </div>
        </div>

        <!-- 5. Grupo piloto -->
        <div class="border rounded-lg p-4 mb-4" id="dct-piloto">
          <div class="kb-section-title">Grupo piloto ({{ piloto?.personas?.length ?? estado.piloto_total }})</div>
          <p class="kb-hint mb-2">Con la invitación en «grupo piloto», solo estas personas ven la invitación a aceptar los términos de CrediTotal.</p>
          <div *ngIf="errorPiloto" class="kb-aviso kb-aviso-alerta mb-2"><i class="fas fa-exclamation-triangle"></i><div>{{ errorPiloto }}</div></div>
          <div *ngIf="piloto?.personas?.length" class="kb-table-envoltorio mb-3">
            <table class="kb-table">
              <thead class="kb-thead"><tr><th class="kb-th">Cédula</th><th class="kb-th">Nombre</th><th class="kb-th"></th></tr></thead>
              <tbody>
                <tr class="kb-tr" *ngFor="let p of piloto.personas">
                  <td class="kb-td">{{ p.cedula || '—' }}</td>
                  <td class="kb-td">{{ p.nombre }}</td>
                  <td class="kb-td text-right">
                    <button type="button" class="kb-btn kb-btn-outline kb-btn-sm" [disabled]="guardando" (click)="quitarDelPiloto(p)">Quitar</button>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <div *ngIf="piloto && !piloto.personas?.length" class="kb-hint mb-3">Todavía no hay personas en el grupo piloto.</div>
          <div class="flex items-center gap-2">
            <input type="text" inputmode="numeric" class="kb-input flex-1" placeholder="Cédula, solo números" aria-label="Cédula para agregar al grupo piloto"
                   [(ngModel)]="cedulaNueva" [disabled]="guardando" (keyup.enter)="agregarAlPiloto()">
            <button type="button" class="kb-btn kb-btn-primary" [disabled]="!cedulaValida()" (click)="agregarAlPiloto()">Agregar</button>
          </div>
          <div *ngIf="piloto?.historia?.length" class="kb-table-envoltorio mt-3">
            <table class="kb-table">
              <thead class="kb-thead"><tr><th class="kb-th">Fecha</th><th class="kb-th">Cambio</th><th class="kb-th">Quién</th><th class="kb-th">Motivo</th></tr></thead>
              <tbody>
                <tr class="kb-tr" *ngFor="let h of piloto.historia">
                  <td class="kb-td">{{ h.fecha | date:'dd/MM/yyyy HH:mm' }}</td>
                  <td class="kb-td">{{ h.accion === 'AGREGAR' ? 'Agregó' : 'Quitó' }} {{ h.cedula }}</td>
                  <td class="kb-td">{{ h.usuario || '—' }}</td>
                  <td class="kb-td">{{ h.motivo }}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>

        <!-- 5. Historiales -->
        <div class="grid gap-4 md:grid-cols-2" id="dct-historial">
          <div>
            <div class="kb-section-title">Historial de la invitación</div>
            <div *ngIf="!estado.historia_invitacion?.length" class="kb-hint">Sin cambios todavía.</div>
            <div *ngIf="estado.historia_invitacion?.length" class="kb-table-envoltorio">
              <table class="kb-table">
                <thead class="kb-thead"><tr><th class="kb-th">Fecha</th><th class="kb-th">Cambio</th><th class="kb-th">Quién</th><th class="kb-th">Motivo</th></tr></thead>
                <tbody>
                  <tr class="kb-tr" *ngFor="let h of estado.historia_invitacion">
                    <td class="kb-td">{{ h.fecha | date:'dd/MM/yyyy HH:mm' }}</td>
                    <td class="kb-td">{{ textoModo(h.de) }} → {{ textoModo(h.a) }}</td>
                    <td class="kb-td">{{ h.usuario?.username || h.usuario || '—' }}</td>
                    <td class="kb-td">{{ h.motivo }}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
          <div>
            <div class="kb-section-title">Historial de la empresa que cobra</div>
            <div *ngIf="!estado.historia_empresa?.length" class="kb-hint">Sin cambios todavía.</div>
            <div *ngIf="estado.historia_empresa?.length" class="kb-table-envoltorio">
              <table class="kb-table">
                <thead class="kb-thead"><tr><th class="kb-th">Fecha</th><th class="kb-th">Cambio</th><th class="kb-th">Resultado</th><th class="kb-th">Quién</th><th class="kb-th">Motivo</th></tr></thead>
                <tbody>
                  <tr class="kb-tr" *ngFor="let h of estado.historia_empresa">
                    <td class="kb-td">{{ h.fecha | date:'dd/MM/yyyy HH:mm' }}</td>
                    <td class="kb-td">{{ textoEmpresaCorta(h.de) }} → {{ textoEmpresaCorta(h.a) }}</td>
                    <td class="kb-td">
                      <span class="kb-badge" [ngClass]="h.resultado === 'RECHAZADA' ? 'kb-badge-peligro' : 'kb-badge-exito'">{{ h.resultado === 'RECHAZADA' ? 'Rechazada' : 'Aplicada' }}</span>
                    </td>
                    <td class="kb-td">{{ h.usuario?.username || h.usuario || '—' }}</td>
                    <td class="kb-td">{{ h.motivo }}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </ng-container>
    </div>
  </div>
</div>
